import { compile } from '@intlify/core-base'
import { createI18n } from 'vue-i18n'

import { en } from './en'
import type { MessageKey } from './en'
import { useI18n } from './useI18n'

export type { MessageKey }

type MessageOverrides = Partial<Record<MessageKey, string>>

function filterLanguageStrings(messages: MessageOverrides) {
  return Object.fromEntries(
    Object.entries(messages)
      .filter(([key]) => key.startsWith('i18n:'))
      .map(([key, value]) => [key.replace('i18n:', ''), value]),
  )
}

// filter strings that do not start with i18n: or kiosk: prefix
// attach custom_strings prefix to each key
function filterCustomStrings(messages: MessageOverrides) {
  return Object.fromEntries(
    Object.entries(messages)
      .filter(([key]) => !key.startsWith('i18n:') && !key.startsWith('kiosk:'))
      .map(([key, value]) => [`custom_strings.${key}`, value]),
  )
}

function installLanguage(portalMessages: MessageOverrides = {}, sellerOverrides: MessageOverrides = {}) {
  const portalLanguageStrings = filterLanguageStrings(portalMessages)
  const sellerLanguageStrings = filterLanguageStrings(sellerOverrides)

  const customStrings = filterCustomStrings(portalMessages)
  const customSellerStrings = filterCustomStrings(sellerOverrides)

  const defaults = {
    ...en,
    ...portalLanguageStrings,
    ...sellerLanguageStrings,
    ...customStrings,
    ...customSellerStrings,
  }

  const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en: { ...defaults } },
    missingWarn: false,
    fallbackWarn: false,
    warnHtmlMessage: false,
    messageCompiler(message, context) {
      try {
        return compile(message, context)
      } catch (e) {
        /* eslint-disable-next-line no-console */
        console.error(`[i18n] compile failed for "${context.key}":`, e)
        return () => ''
      }
    },
  })
  return i18n
}

export { installLanguage, useI18n }
